import React from 'react';
import { useTranslation } from 'react-i18next';

export const PRIORITY_CONFIG = {
  critical: { labelKey: 'screens.claimsScreen.priorityCritical', color: '#dc2626' },
  high: { labelKey: 'screens.claimsScreen.priorityHigh', color: '#ea580c' },
  medium: { labelKey: 'screens.claimsScreen.priorityMedium', color: '#d97706' },
  low: { labelKey: 'screens.claimsScreen.priorityLow', color: '#16a34a' },
};

const PriorityDot = ({ priority }) => {
  const { t } = useTranslation();
  const cfg = PRIORITY_CONFIG[priority] || PRIORITY_CONFIG.medium;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#475569' }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: cfg.color }} />
      {t(cfg.labelKey)}
    </span>
  );
};

export default PriorityDot;
